import { render, staticRenderFns } from "./divisiNew.vue?vue&type=template&id=2c0fbf26"
import script from "./divisiNew.vue?vue&type=script&lang=js"
export * from "./divisiNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports